module.exports = __webpack_public_path__ + "img/12.3d123cd3.jpg";